import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { ReactComponent as UserIcon } from '../../../assets/icons/user-icon.svg';
import { ReactComponent as CeoAdminIcon } from '../../../assets/icons/coe-admin-login-icon.svg';
import { ReactComponent as ArrowLeft } from '../../../assets/icons/arrow-left.svg';
import { ReactComponent as PencilPurple } from '../../../assets/icons/pencil_purple.svg';
import { clearForm } from 'store/forms/actions';

const LoginAs = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Every time clear form store and restart to initial state
  useEffect(() => {
    dispatch(clearForm(false));
  }, [dispatch]);

  return (
    <div className="main-wrapper login-bg">
      <div className="main-wrapper-content login-as-wrapper">
        <div className="login-as-page-content">
          <div id="login-header" className="login-header">
            Είσοδος στην Πλατφόρμα ως
          </div>

          <div id="button-container-1" className="button-container">
            <div
              id="login-button-client"
              className="login-button"
              onClick={() => navigate('/login')}
            >
              <UserIcon />
              <span>Πελάτης</span>
            </div>
            <div
              id="login-button-partner"
              className="login-button"
              onClick={() => navigate('/login')}
            >
              <CeoAdminIcon />
              <span>Center of Excellence</span>
            </div>
            <div
              id="login-button-store"
              className="login-button"
              onClick={() => navigate('/login')}
            >
              <CeoAdminIcon />
              <span>Διαχειριστής</span>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div id="go-back" className="go-back">
              <Link to={'/'}>
                <ArrowLeft />
                <span>Επιστροφή στην Αρχική</span>
              </Link>
            </div>
            <div id="want-register-btn" className="want-register-btn">
              <Link to={'/register'}>
                <PencilPurple />
                <span>Θέλω να Εγγραφώ</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginAs;
